'use client';

import { Checkbox } from '~/components/ui/checkbox';
import React from 'react';
interface CheckboxInputGroupProps {
  id: string;
  name: string;
  value: string;
  label?: string;
  checked?: boolean;
  updateChecked?: (checked: boolean) => void;
}

export function CheckboxInputGroup({
  id,
  name,
  value,
  label,
  checked,
  updateChecked,
}: CheckboxInputGroupProps) {
  return (
    <div className="flex items-center gap-x-2">
      <Checkbox
        id={String(id)}
        name={name}
        value={value}
        checked={checked}
        onClick={() => {
          updateChecked?.(!checked);
        }}
      />
      {label && (
        <label
          htmlFor={String(id)}
          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
        >
          {label}
        </label>
      )}
    </div>
  );
}
